import { Noticeboard, ViewNotice } from '@features/noticeboard'
import { UserRole } from '@lmc/ts-common'
import { Navigate, Route } from 'react-router-dom'

const INDEX = 'noticeboard'
const VIEW = ':id'

// CM-3757: the IT role has no noticeboard access (no Notice permission) and the
// page doesn't load for them. Hiding the nav icon isn't enough — block the
// route too so /noticeboard and /noticeboard/:id can't be reached via deep link.
export const noticeboardRoutes = (role?: UserRole | null) =>
  role === UserRole.it ? (
    <Route path={INDEX} element={<Navigate to="/" replace />} />
  ) : (
    <Route path={INDEX}>
      <Route element={<Noticeboard />} index />
      <Route path={VIEW} element={<ViewNotice />} />
    </Route>
  )

export default noticeboardRoutes
